import {JourneyTrack} from '../journey-track';
import {TrackInfo} from '../model/track-info';
import {TrackTypes} from '../model/track-types';
import {DomainOrigin} from "../../../domains/model/domain-origin";
import {TrackActionResult} from "../model/track-action-result";
import {DataOrigin} from "../../../../model/DataOrigin";
import {environment} from "../../../../../../environments/environment";
import {ContaIonDataParse} from "./util/conta-ion-data-parse";
import {MaritalStatusAction} from "./actions/marital-status-action";
import {CacheService} from "../../../comunicator-native/cache/v2/cache.service";
import { MobileMockData } from './util/mobile-mock-data';
import { Platform } from '@ionic/angular';

export class ContaIonMaritalTrack extends JourneyTrack {

    private canEditMaritalStatus = true;
    private canEditSpouse = true;
    
    private readonly originalTracks = [

        new TrackInfo('marital-status', ['marital-status', 'marital-status'],
            undefined, {
            domainOrigin: DomainOrigin[environment.contaIonDomainOrigin],
            canEdit:this.canEditMaritalStatus,    
                actionName: ActionList.MaritalStatus}),
        new TrackInfo('spouse', ['marital-status', 'spouse'],
            undefined, {
            dataOrigin: DataOrigin[environment.contaIonDataOrigin],
                canEdit:this.canEditSpouse,
            }),

    ];

    track = [];

    constructor(private cacheNativeService: CacheService, private platform: Platform) {
        super();
        this.track = this.originalTracks;
    }

    public getName(): TrackTypes {
        return TrackTypes.CONTA_ION_MARITAL;
    }

    public getTrack(): TrackInfo[] {
        return this.track;
    }
    
    public isUncoupled() {
        return true;
    }

    public async loadData() {
        //MobileMockData.executeMockCall(500);
        const data = await this.cacheNativeService.getItemCommunicator();
        return Promise.resolve(ContaIonDataParse.parseFromMobileData(data));
    }

    public executeAction(actionName, data): TrackActionResult {

        switch (actionName) {
            case ActionList.MaritalStatus:
                return MaritalStatusAction.execute(data, this.track, this.originalTracks)
        }

    }

    isEventComunicator() {
        return true;
    }

    isBackHeader() {
        return this.platform.is('android');
    }

}

export enum ActionList{
    MaritalStatus = 'marital-status'
}